// extracted by mini-css-extract-plugin
export default {"page":"subscription-details_page__Hv1+P"};